import AjaxForm, {EVENT_SUCCESS, EVENT_ERROR} from "webPage/AjaxForm";
import {scrollToElement} from "util/general";
import PageAnimations from "webPage/PageAnimations";

export default class MeasuringGuides {

    constructor($element) {
        this.$element = $element;
        this.$form = this.$element.find('.js-form');
        this.$content = this.$element.find('.js-content-section');

        this.form = new AjaxForm(this.$form, async ($form, formData) => {
            scrollToElement(this.$form.find('.js-fieldset:last-child'), 300, 0);
            this.$content.slideUp().html('');
            this.fireGTagEvent(formData);
            return Ajax.get('leamington-blinds', 'measuring-guides', formData);
        });

        this.request = null;

        this.bindEvents();
    }


    fireGTagEvent(formData) {
        try {
            let eventData = {
                "event": "measurement-tool-submit",
                "type-of-window": this.$form.find('.js-radio[name="measuring-guides-window"][value="' + formData['measuring-guides-window'] + '"]').attr('data-term-slug'),
                "type-of-blind-shutter": this.$form.find('.js-radio[name="measuring-guides-type"][value="' + formData['measuring-guides-type'] + '"]').attr('data-term-slug'),
                "type-of-fit": this.$form.find('.js-radio[name="measuring-guides-fit"][value="' + formData['measuring-guides-fit'] + '"]').attr('data-term-slug'),
            };
            dataLayer.push(eventData);
        } catch (e) {
            console.log(e);
        }
    }

    bindEvents() {
        let me = this;

        this.$form.on('click', '.js-radio', function () {
            let $this = $(this);
            let $fieldset = $this.parents('.js-fieldset');

            let $nextFieldSet = $fieldset.next('.js-fieldset');

            if ($nextFieldSet.length > 0) {
                if (!$nextFieldSet.is(':visible')) {
                    $nextFieldSet.removeClass('a--play').addClass('a');
                    $nextFieldSet.find('fieldset').addClass('a__i a__i--fade-in-up a__i--dur-600');
                    $nextFieldSet.show();
                    scrollToElement($nextFieldSet, 300, 180);
                    setTimeout(() => {
                        PageAnimations.check();
                    }, 300);
                }
            }

            me.$content.slideUp().html('');

            if ($this.attr('name') === 'measuring-guides-type') {
                let $perfect_fit = me.$element.find('.js-radio[name="measuring-guides-fit"][data-term-slug="perfect-fit"]');
                if ($this.attr('data-term-slug') !== 'blinds') {
                    $perfect_fit[0].checked = false;
                    $perfect_fit.prop('disabled', true).attr('data-no-validate', true);
                    $perfect_fit.parents('.js-guide-radio').removeClass('guide-radio--selected').addClass('guide-radio--disabled');
                } else {
                    $perfect_fit.prop('disabled', false).removeAttr('data-no-validate');
                    $perfect_fit.parents('.js-guide-radio').removeClass('guide-radio--disabled');
                }

                me.form.validator.updateInputs();
            }

            $fieldset.find('.guide-radio--selected').removeClass('guide-radio--selected');
            $this.parents('.js-guide-radio').addClass('guide-radio--selected');
        });

        this.form.on(EVENT_SUCCESS, (data) => {
            if (data.status === 'success') {
                this.$content.html(data.content).slideDown();
                scrollToElement(this.$form.find('.js-fieldset:last-child'), 300, 0);
            } else {
                this.$element.find('.js-message-holder').append((eotwJSXFactory('div', {class: "message message--error"}, [eotwJSXFactory('p', null, ["We could not get the measuring guides for that selection, please try again."])])));
            }
            this.$form.find('button[type="submit"]').removeClass('btn--loading');
        }).on(EVENT_ERROR, (e) => {
            console.trace('error', e);
            this.$element.find('.js-message-holder').append((eotwJSXFactory('div', {class: "message message--error"}, [eotwJSXFactory('p', null, ["We could not get the measuring guides for that selection, please try again."])])));
            this.$form.find('button[type="submit"]').removeClass('btn--loading');
        });
    }
}
